module.exports = __webpack_public_path__ + "img/desktop-6.f06a23bb.jpg";